import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

@Injectable({
    providedIn: 'root'
})
export class DrawerService {
    private sidenav: MatSidenav;

    setDrawer(sidenav: MatSidenav): void {
        this.sidenav = sidenav;
    }

    toggle(): void {
        if (!this.sidenav) {
            console.warn('DrawerService: sidenav not set yet.');
            return;
        }
        void this.sidenav.toggle();
    }

    open(): void {
        if (!this.sidenav) return;
        void this.sidenav.open();
    }

    close(): void {
        if (!this.sidenav) return;
        void this.sidenav.close();
    }
}
